var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUisses3Male(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 120,
    viewBox: "0 0 104 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4155_2734)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4155_2734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: -1,
    width: 91,
    height: 121
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 -0.259766H7.5V119.74H97.5V-0.259766Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4155_2734)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4155_2734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 103,
    height: 115
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 2.74023H1V116.74H104V2.74023Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4155_2734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.87 40.2402C27.87 40.2402 36.81 43.7902 54.2 44.6702C69.61 44.8302 78.53 40.5002 78.53 40.5002C78.53 40.5002 80.55 49.6702 81.42 54.8902C81.99 58.3202 82.29 67.0802 82.29 67.0802L82.5 78.2402L82.29 89.2402L81.42 99.2402L78.31 108.74C78.31 108.74 75.18 110.47 66 110.24C56.82 110.01 55.5 110.24 55.5 110.24L53.76 91.7402V72.9702L51.55 72.5802L51.5 80.2402L52 96.2402L51.55 103.74L50 110.74C50 110.74 49.13 111.65 37 110.74C24.87 109.83 26 109.24 26 109.24L23.5 102.24L22.23 92.2402V71.5802L23.1 64.4702L23.97 60.1202L25.71 50.5402L27.87 40.2402Z",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6298 -17.4399C25.8398 -15.8599 24.9698 -11.7699 25.3698 -9.10994C25.9498 -5.20994 26.4598 -1.78994 27.0698 1.43006C28.7598 10.2601 28.8198 10.1601 29.6798 16.5001C30.3798 21.7001 30.2198 24.3001 29.5098 27.2601C28.7998 30.2201 28.1398 32.9901 27.8898 37.9101C27.8298 39.1101 27.8598 40.1001 27.8898 40.7401C25.3698 51.3401 21.8198 65.4401 22.2298 81.8701C22.2298 90.5301 22.0398 100.8 26.3098 109.28",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.96 110.63C51.82 103.04 52.08 99.3402 51.82 92.3302C51.54 84.7402 50.92 78.1002 51.54 72.5802C51.84 72.7202 52.22 72.8502 52.67 72.9202C53.97 73.1202 55.02 72.7002 55.5 72.4702",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3098 109.74C54.4398 98.4202 55.3098 108 54.4398 98.4202C53.5698 92.3302 53.9798 75.3402 53.5898 72.9702",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.54 108.4C82.3 98.1301 82.21 91.7801 82.3 85.6301C82.4 78.6601 82.81 84.1101 82.3 67.0801C82.19 63.4401 81.11 53.9101 79.87 47.2101C79.4 44.6501 78.89 42.5401 78.51 41.0901C78.59 39.3601 78.61 36.7101 78.29 33.5001C77.71 27.9101 76.41 26.0801 75.77 21.8301C75.04 16.9401 76.49 16.3601 77.84 8.23008C79.25 -0.259924 79.34 -1.42992 78.97 -6.49992C78.89 -7.57992 79.36 -10.0199 79.17 -13.2999C79.02 -15.9099 79.42 -19.4699 79.04 -21.1699",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0798 -53.98C61.5998 -50.42 61.7798 -47.51 62.0598 -45.77C62.1998 -44.92 62.5598 -44.11 63.1398 -43.47C64.2698 -42.21 65.7798 -41.41 67.5098 -40.87C67.5798 -40.85 67.6498 -40.82 67.7098 -40.79L75.0198 -37.58C75.0698 -37.56 75.1298 -37.53 75.1798 -37.52C80.3298 -35.78 81.9598 -35.89 84.1898 -34.72C88.9798 -32.19 91.3798 -23.1 91.3798 -17.04C91.3798 -15.82 91.2998 -15.85 89.7198 -6.38998C88.8598 -1.24998 88.0098 3.86002 87.6798 6.19002C86.3598 15.48 87.4098 22.27 87.8498 27.77C88.4598 35.47 88.3498 46.85 84.7898 62.1C85.1698 66.26 84.4698 69.61 84.6198 71.96C84.7898 74.68 84.8298 74.42 84.6198 74.92C83.3198 78 83.6398 78.2 82.2798 79.27",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9899 -53.98C43.4699 -50.42 43.2899 -47.51 43.0099 -45.77C42.8699 -44.92 42.5099 -44.11 41.9299 -43.47C40.7999 -42.21 39.2899 -41.41 37.5599 -40.87C37.4899 -40.85 37.4199 -40.82 37.3599 -40.79L30.0499 -37.58C29.9999 -37.56 29.9399 -37.53 29.8899 -37.52C24.9699 -35.86 22.1199 -35.15 20.8799 -34.72C15.8499 -32.96 14.4099 -23.79 14.0599 -21.55C13.8099 -19.92 13.6399 -17.85 15.3399 -6.38998C16.5099 1.45002 16.9299 2.77002 17.3799 6.19002C18.5899 15.38 17.6799 22 17.2999 26.64C16.6699 34.39 16.7599 45.95 20.2599 62.1C19.8799 66.26 20.4099 66.47 20.2599 68.82C20.0899 71.54 19.7199 71.9 21.3599 75.78C22.6599 78.86 20.8699 76.45 22.2299 77.52",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8696 24.7702C53.6196 24.0102 54.8496 24.0102 55.6096 24.7702",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5198 62.5601C8.27979 77.0101 7.56979 85.1401 12.9498 99.6101",
    stroke: "#2E2E2E",
    strokeWidth: 0.89,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4799 99.96C96.6599 85.1 95.6799 76.97 88.8799 63.02",
    stroke: "#2E2E2E",
    strokeWidth: 0.89,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3198 48.7402C53.3198 48.7402 54.8998 70.4002 51.5498 72.5802",
    stroke: "#2E2E2E",
    strokeWidth: 0.23,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6999 41.9104C48.4499 45.3404 55.2899 49.3104 78.6099 41.8804L79.5499 45.5704C64.1199 51.7504 46.7699 50.8104 26.6499 46.1504L27.6999 41.9104Z",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.52 44.8703C64.52 44.8703 66.38 47.3402 65.73 50.2702L68.63 49.4502C68.63 49.4502 69.57 45.6703 67.69 44.0103L64.52 44.8802V44.8703Z",
    fill: "#747474"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5897 44.6804C44.5897 44.6804 42.7297 47.7104 43.3797 50.7204L40.4797 49.8704C40.4797 49.8704 39.5997 45.8204 41.4797 44.1104L44.5897 44.6804Z",
    fill: "#747474"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9198 41.8602C30.9198 41.8602 29.6498 45.3402 30.0898 48.7402L28.1198 47.7802C28.1198 47.7802 27.4598 43.6702 28.7398 41.7402L30.9198 41.8602Z",
    fill: "#747474"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4097 42.5804C74.4097 42.5804 75.5897 45.4404 75.1797 48.8404L77.0197 47.8804C77.0197 47.8804 77.7897 43.8104 76.5997 41.8804L74.4097 42.5804Z",
    fill: "#747474"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.04 45.8003L56.83 46.1103C57.13 46.1303 57.08 46.5303 57.08 46.7503L57.1 49.3703C57.1 49.6103 57.11 50.0403 56.8 50.0303L51.96 49.8803",
    stroke: "white",
    strokeWidth: 0.28,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6797 47.8904C56.6797 47.8904 57.9697 48.4404 58.5397 47.6304",
    stroke: "white",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3198 47.9203C60.4799 47.9203 60.6098 47.7905 60.6098 47.6303C60.6098 47.4702 60.4799 47.3403 60.3198 47.3403C60.1596 47.3403 60.0298 47.4702 60.0298 47.6303C60.0298 47.7905 60.1596 47.9203 60.3198 47.9203Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1997 48.3603C54.3598 48.3603 54.4897 48.2304 54.4897 48.0703C54.4897 47.9101 54.3598 47.7803 54.1997 47.7803C54.0395 47.7803 53.9097 47.9101 53.9097 48.0703C53.9097 48.2304 54.0395 48.3603 54.1997 48.3603Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3798 48.2104C50.54 48.2104 50.6698 48.0805 50.6698 47.9204C50.6698 47.7602 50.54 47.6304 50.3798 47.6304C50.2197 47.6304 50.0898 47.7602 50.0898 47.9204C50.0898 48.0805 50.2197 48.2104 50.3798 48.2104Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6899 47.4203C63.8501 47.4203 63.9799 47.2905 63.9799 47.1303C63.9799 46.9702 63.8501 46.8403 63.6899 46.8403C63.5297 46.8403 63.3999 46.9702 63.3999 47.1303C63.3999 47.2905 63.5297 47.4203 63.6899 47.4203Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4401 49.9302C28.3301 54.5902 26.6001 59.4002 23.3901 63.0002C26.3801 59.1802 28.2601 54.5702 29.4401 49.9302Z",
    fill: "#2E2E2E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1601 64.0303C31.7501 71.7003 31.7501 79.5603 31.7001 87.3303C31.8301 94.1303 31.9601 101 33.3001 107.69C33.4601 108.65 33.8001 109.57 34.0901 110.5C33.7601 109.63 33.4301 108.65 33.2401 107.7C31.7701 101.03 31.6501 94.1303 31.5601 87.3303C31.6501 79.5703 31.6501 71.6303 33.1601 64.0303Z",
    fill: "#2E2E2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3699 110.13C72.8699 94.4803 73.8299 78.7403 73.2399 63.0103H73.2499C74.0699 78.7203 72.9499 94.5303 71.3599 110.13H71.3699Z",
    fill: "#2E2E2E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8501 48.7305C78.9801 51.9705 80.7401 56.5105 81.6601 59.7405C80.4401 56.6105 78.9001 51.9405 77.8501 48.7305Z",
    fill: "#2E2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4155_2734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 120,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUisses3Male);
export default __webpack_public_path__ + "static/media/сuisses-3-male.87cc7db477cff1c68704d92aa17f3d23.svg";
export { ForwardRef as ReactComponent };